export enum MetadataName {
  InitialBrowserName = 'INTBR',
  InitialBrowserVersion = 'INTBRVRSN',
  InitialOSVersion = 'IOSVRSN',
  FingerprintID = 'FNGRPRNTID',
  LatestBrowserName = 'LTSTBR',
  LatestBrowserVersion = 'LTSTBRVRSN',
  LatestOSVersion = 'LOSVRSN',
  QuoteCompleteCount = 'FQC',
  QuoteCompleteDateTime = 'FQCDT',
  PolicyDetailsCount = 'FPD',
  PolicyDetailsDateTime = 'FPDDT',
  ConfirmAndPayCount = 'FCAP',
  ConfirmAndPayDateTime = 'FCAPDT',
}
